(ns humbleai.belt.set)

(defn toggle-membership
  "Given `set` and any `value` if value is present set disj it from the set else conj it to the set"
  [set value]
  (if (contains? set value)
    (disj set value)
    (conj set value)))
